export const environment = {
  env: 'DEV',
  production: false,
  serverBaseUrl: 'http://engageapi.azurewebsites.net',
  serverUrl: 'http://engageapi.azurewebsites.net/api',
  loginUrl: 'https://investor-portal-backend.herokuapp.com'
};
